<template>
  <div>
    <el-dialog
      :visible="visible"
      title="合同确认配置"
      width="85%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="handleClose"
    >
    <el-table :data="configList" border size="mini">
      <!-- 启用状态 -->
      <el-table-column label="启用状态" align="center" min-width="100">
        <template v-slot="{ row }">
          <el-switch
            v-model="row.enabled"
            active-text="是"
            inactive-text="否"
            :active-value="true"
            :inactive-value="false"
          />
        </template>
      </el-table-column>
      <!-- 合同确认类型 -->
      <el-table-column
        prop="typeName"
        label="合同确认类型"
        align="center"
        min-width="140"
      >
        <template v-slot="{ row }">
          {{ row.templateName }}
        </template>
      </el-table-column>
      <!-- 合同确认模版 -->
      <el-table-column label="合同确认模版" align="center" min-width="140">
        <template v-slot="{ row }">
          <el-link type="primary">{{ row.templateName }}</el-link>
        </template>
      </el-table-column>
      <!-- 是否发起审批 -->
      <el-table-column label="是否发起审批" align="center" min-width="130">
        <template v-slot="{ row }">
          <el-radio-group v-model="row.whetherInitiateAudit">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>
      <!-- 审批方式 -->
      <el-table-column label="审批方式" align="center" min-width="280">
        <template v-slot="{ row }">
          <template v-if="row.whetherInitiateAudit">
            <el-radio-group v-model="row.auditMethod">
              <el-radio label="FEISHU">飞书审批</el-radio>
              <el-radio disabled label="MTDS">mtds审单任务</el-radio>
            </el-radio-group>
            <!-- <div v-if="row.auditMethod === 'FEISHU'" style="margin-top: 4px">
              <el-input
                v-model="row.feishuApprovalFlowId"
                placeholder="填写审批流程ID"
                size="mini"
                style="width: 200px"
              />
            </div> -->
          </template>
        </template>
      </el-table-column>
      <!-- 审核人设置 -->
      <el-table-column label="审核人设置" align="center" min-width="200">
        <template v-slot="{ row }">
          <div style="display: flex; align-items: center; gap: 8px">
            <span
              v-if="getReviewerSummary(row)"
              style="color: #e6a23c; font-size: 12px"
            >
              {{ getReviewerSummary(row) }}
            </span>
            <el-button
              type="primary"
              size="mini"
              style="padding: 0"
              @click="openReviewerDialog(row)"
            >
              添加
            </el-button>
          </div>
        </template>
      </el-table-column>
      <!-- 是否可关联抵扣 -->
      <el-table-column
        v-if="showDeductionColumn"
        label="是否可关联抵扣"
        align="center"
        min-width="120"
      >
        <template v-slot="{ row }">
          <el-radio-group v-model="row.canDeduct">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm"
        >保 存</el-button
      >
    </span>
  </el-dialog>
  <!-- 审核人设置对话框 -->
  <reviewer-setting-dialog
    :visible="reviewerDialogVisible"
    :reviewers="currentReviewerRow ? currentReviewerRow.reviewers : []"
    @close="handleCloseReviewerDialog"
    @confirm="handleConfirmReviewer"
  />
  </div>
</template>

<script>
import ReviewerSettingDialog from "./ReviewerSettingDialog.vue";
import { saveAuditConfigDetail } from "@/api/quotaion/designQuotationEContractAuditController/saveAuditConfigDetail/post.js";

// 默认配置项
const DEFAULT_CONFIGS = [
  {
    typeCode: "CUSTOMER_CONFIRM",
    typeName: "定制合同确认",
    templateName: "定制合同确认模板",
    enabled: true,
    whetherInitiateAudit: 1,
    auditMethod: "FEISHU",
    feishuApprovalFlowId: "",
    canDeduct: false,
    reviewers: [],
  },
  {
    typeCode: "LAZY_CAT_CUSTOMER_CONFIRM",
    typeName: "配套合同确认",
    templateName: "配套合同确认模板",
    enabled: false,
    whetherInitiateAudit: 1,
    auditMethod: "FEISHU",
    feishuApprovalFlowId: "",
    canDeduct: false,
    reviewers: [],
  },
  {
    typeCode: "DECORATION_CUSTOMER_CONFIRM",
    typeName: "装修合同确认",
    templateName: "装修合同确认模板",
    enabled: false,
    whetherInitiateAudit: 1,  
    auditMethod: "FEISHU",
    feishuApprovalFlowId: "",
    canDeduct: false,
    reviewers: [],
  },
  {
    typeCode: "STATE_SUBSIDIES_CUSTOMER_CONFIRM",
    typeName: "国补合同确认",
    templateName: "国补合同确认模板",
    enabled: false,
    whetherInitiateAudit: 0,
    auditMethod: "FEISHU",
    feishuApprovalFlowId: "",
    canDeduct: false,
    reviewers: [],
  },
  {
    typeCode: "GROSS_PROFIT_MARGIN_NON_STANDARD",
    typeName: "合同毛利不达标审批",
    templateName: "合同毛利不达标审批模板",
    enabled: true,
    whetherInitiateAudit: 0,
    auditMethod: "FEISHU",
    feishuApprovalFlowId: "",
    canDeduct: false,
    reviewers: [],
  },
];

export default {
  name: "ContractConfirmConfigDialog",
  components: { ReviewerSettingDialog },
  props: {
    visible: Boolean,
    // 外部传入的已有配置数据，用于回显
    configData: {
      type: Array,
      default: () => [],
    },
    // 组织编码
    orgNo: {
      type: String,
      default: "",
    },
    // 组织ID
    orgId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      configList: [],
      reviewerDialogVisible: false,
      currentReviewerRow: null,
    };
  },
  computed: {
    showDeductionColumn() {
      return this.configList.some((row) => row.typeCode === "STATE_SUBSIDIES_CUSTOMER_CONFIRM");
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.initConfigList();
        }
      },
    },
  },
  methods: {
    /**
     * 初始化配置列表，优先使用外部传入数据
     */
    initConfigList() {
      if (this.configData && this.configData.length > 0) {
        // 使用外部传入数据，补充缺失字段
        this.configList = DEFAULT_CONFIGS.map((item) => ({
          ...item,
          ...this.configData.find((d) => d.typeCode === item.typeCode) || {},
          reviewers: Array.isArray((this.configData.find((d) => d.typeCode === item.typeCode) || {}).reviewers) ? (this.configData.find((d) => d.typeCode === item.typeCode) || {}).reviewers : [],
        }));
      } else {
        // 使用默认配置
        this.configList = JSON.parse(JSON.stringify(DEFAULT_CONFIGS));
      }
    },
    /**
     * 获取审核人摘要文本
     */
    getReviewerSummary(row) {
      if (!row.reviewers || row.reviewers.length === 0) return "";
      const activeReviewers = row.reviewers.filter((r) => r.checked);
      if (activeReviewers.length === 0) return "";
      const parts = activeReviewers.map((r) => {
        const alias = r.alias || `第${this.getLevelLabel(r.level)}审核人`;
        if (r.targetType === "designated" && r.designatedUsers && r.designatedUsers.length > 0) {
          const names = r.designatedUsers.map((u) => u.name).join(",");
          return `${alias}（${names}）`;
        }
        return `${alias}（任意人）`;
      });
      return parts.join(" - ");
    },
    getLevelLabel(level) {
      const labels = { 1: "一", 2: "二", 3: "三", 4: "四", 5: "五" };
      return labels[level] || level;
    },
    /**
     * 打开审核人设置对话框
     */
    openReviewerDialog(row) {
      // 确保 reviewers 数组有4级
      if (!row.reviewers || row.reviewers.length === 0) {
        row.reviewers = [1, 2, 3, 4, 5].map((level) => ({
          level,
          checked: false,
          alias: "",
          targetType: "any", // any | designated
          designatedUsers: [],
        }));
      }
      this.currentReviewerRow = row;
      this.reviewerDialogVisible = true;
    },
    handleCloseReviewerDialog() {
      this.reviewerDialogVisible = false;
      this.currentReviewerRow = null;
    },
    handleConfirmReviewer(reviewers) {
      if (this.currentReviewerRow) {
        this.$set(this.currentReviewerRow, "reviewers", reviewers);
      }
      this.handleCloseReviewerDialog();
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    handleConfirm() {
      // 转换数据格式以匹配API要求
      const apiData = this.configList.map((item) => {
        // 转换审核人配置
        const approverRoleConfigList = (item.reviewers || [])
          .filter((r) => r.checked)
          .map((r) => ({
            roleConfig: {
              id: r.id || undefined,
              name: r.alias || `第${this.getLevelLabel(r.level)}审核人`,
              nickName: r.alias || "",
              level: r.level,
              specifyType: r.targetType === "designated" ? "SPECIFIC" : "ALL",
            },
            approverList: (r.designatedUsers || []).map((u) => ({
              id: u.id || undefined,
              approverId: u.approverId || undefined,
              approver: u.name,
              approverAccount: u.account || "",
            })),
          }));

        return {
          id: item.id || undefined,
          enable: item.enabled ? 1 : 0,
          contractConfirmType: item.typeCode,
          // contractConfirmTemplateType: item.templateType || "",
          contractConfirmTemplateName: item.templateName,
          whetherInitiateAudit: item.whetherInitiateAudit,
          whetherAssociatedDeduction: item.canDeduct ? 1 : 0,
          auditMethod: item.auditMethod,
          processId: item.feishuApprovalFlowId || "",
          orgId: this.orgId,
          orgNo: this.orgNo,
          approverRoleConfigList,
        };
      });

      // 调用保存接口
      saveAuditConfigDetail(apiData)
        .then((res) => {
          if (res && res.status) {
            this.$message.success("保存成功");
            this.$emit("update:visible", false);
            this.$emit("confirm", JSON.parse(JSON.stringify(this.configList)));
          } else {
            this.$message.error(res && res.message ? res.message || "保存失败" : "保存失败");
          }
        })
        .catch((error) => {
          console.error("保存配置失败:", error);
          this.$message.error("保存失败");
        });
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}
</style>



// WEBPACK FOOTER //
// ContractConfirmConfigDialog.vue?192fd82e